import { render, staticRenderFns } from "./ReceiverDetails.vue?vue&type=template&id=aca9354c&"
import script from "./ReceiverDetails.vue?vue&type=script&lang=js&"
export * from "./ReceiverDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports